import Input from "@/app/components/ui/Inputs/Input";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "@/constants";
import { useForm } from "react-hook-form";
import useFormValidations from "@/app/hooks/useFormValidations";
import { useNavigate } from "react-router";
import { useWhitelistNumberAPI } from "@/app/hooks/api_hooks/WhitelistNumber/useWhitelistNumberAPI";
import { IWhitelistNumberPostBody } from "@/api_framework/api_modals/Whitelist";
import { toast } from "react-hot-toast";

export interface IWhitelistNumber {
  mobile: number;
}

const WhitelistMobile = () => {
  const formHook = useForm<IWhitelistNumber>({
    mode: "onChange",
    defaultValues: {},
  });
  const navigate = useNavigate();
  const { forMobile } = useFormValidations();
  const { execute: createWhitelistMobile } = useWhitelistNumberAPI();

  const handlePrevStep = () => {
    navigate("/app/configuration");
  };

  const onSubmit = (data: IWhitelistNumber) => {
    if (data) {
      const constructedBody: IWhitelistNumberPostBody = {
        mobile: data?.mobile,
      };
      createWhitelistMobile(constructedBody)
        .then(() => {
          toast.success("Whitelist number added successfully.");
          navigate(`/app/configuration`);
        })
        .catch((error) => {
          toast.error("Error adding whitelist number.");
          console.error(error);
        });
    }
  };

  return (
    <div className="px-4 text-xs">
      <p className="font-bold font-sans text-gray-800 text-left text-lg">
        <span>Whitelist Mobile Number</span>
      </p>
      <form onSubmit={formHook.handleSubmit(onSubmit)} className="mt-6 w-full">
        <div className="flex flex-col sm:flex-row sm:items-end gap-3">
          <div className="w-full max-w-[300px]">
            <div className="flex justify-start items-center gap-1 mb-1.5">
              <span className="font-normal text-black text-xs">Mobile Number</span>
              <span className="font-normal text-rose-600 text-xs">*</span>
            </div>
            <Input
              maxLength={10}
              className="border-slate-400 rounded-md w-full h-9 text-sm"
              inputClassName="text-xs"
              placeholder="Enter mobile number"
              register={formHook.register("mobile", {
                ...forMobile.validations,
                maxLength: 10,
                required: true,
              })}
              fieldError={formHook.formState.errors.mobile}
              errorMessages={[
                forMobile.errors,
                { type: "required", message: "Phone number is required" },
                { type: "maxLength", message: "Invalid phone number" },
              ]}
            />
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <input
              type="submit"
              value={"Save"}
              className={`${PRIMARY_BUTTON} w-full sm:w-auto cursor-pointer`}
              placeholder="Save"
            />
            <div onClick={handlePrevStep} className={`${SECONDARY_BUTTON} w-full sm:w-auto cursor-pointer`}>
              Back
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default WhitelistMobile;
